import {signalStore, withMethods, withState} from "@ngrx/signals";
import { fetchOnInit } from "./features/fetchOnInit.feature.store";

export type Material = {
    id: number,
    name: string,
}

export type MaterialStoreState = {
    materials: Array<Material>,
}

export const materialStore = signalStore(
    { providedIn: "root" },
    withState<MaterialStoreState>({ materials: [] }),
    fetchOnInit< MaterialStoreState, ['materials'], Array<Material> >('/api/material', ['materials']),
    withMethods((store)=>({
        getId: (name: string) => { return  store.materials().find(material => material.name === name)?.id }
    }))
);